export const SvgStar = ({ className = '', size = '19' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.54894 0.761784C8.84829 -0.159526 10.1517 -0.159527 10.4511 0.761783L11.9697 5.43555C12.1035 5.84757 12.4875 6.12653 12.9207 6.12653H17.835C18.8037 6.12653 19.2065 7.36614 18.4228 7.93555L14.447 10.8241C14.0965 11.0787 13.9499 11.5301 14.0838 11.9421L15.6024 16.6159C15.9017 17.5372 14.8472 18.3033 14.0635 17.7339L10.0878 14.8454C9.73729 14.5907 9.2627 14.5907 8.91221 14.8454L4.93647 17.7339C4.15276 18.3033 3.09828 17.5372 3.39763 16.6159L4.91623 11.9421C5.0501 11.5301 4.90344 11.0787 4.55296 10.8241L0.577218 7.93555C-0.206496 7.36614 0.196279 6.12653 1.165 6.12653H6.07929C6.51251 6.12653 6.89647 5.84757 7.03034 5.43555L8.54894 0.761784Z"
      fill="white"
    />
  </svg>
)

export default SvgStar
